import { Button, type ButtonProps } from '@eye-able/ui';
import { CalendarDaysIcon } from 'lucide-react';
import { useInlineTranslation } from '@/i18n/hooks/useInlineTranslation';

export interface OfferBookConsultationButtonProps extends Omit<
  ButtonProps,
  'onClick'
> {
  href?: string;
}

function OfferBookConsultationButton({
  children,
  href,
  size = 'default',
  variant = 'black',
  ...rest
}: OfferBookConsultationButtonProps) {
  const { t, i18n } = useInlineTranslation();

  const resolvedHref =
    href ??
    (i18n.resolvedLanguage === 'de'
      ? 'https://meetings-eu1.hubspot.com/eye-able/produkt-kostenloses-beratungsgespraech'
      : 'https://meetings-eu1.hubspot.com/eye-able/product-free-accessibility-consultation');

  return (
    <Button asChild variant={variant} size={size} {...rest}>
      <a href={resolvedHref} target='_blank' rel='noopener noreferrer'>
        {children ?? (
          <>
            <CalendarDaysIcon aria-hidden />
            {t('bookConsultation')}
          </>
        )}
      </a>
    </Button>
  );
}

export default OfferBookConsultationButton;
